// Deterministic prerender for the dynamic match route.
// See `src/utils/getPrerenderEntries/index.js` and issue #63 for the
// "why". SvelteKit calls `entries()` during prerendering and guarantees
// every returned param is built, replacing the non-deterministic crawler
// traversal that was leaving some `/matches/<slug>/` pages out of `dist/`
// on alternate builds.

import { getMatchSlugpaths } from '$utils/getPrerenderEntries';

export const prerender = true;

export async function entries() {
  return (await getMatchSlugpaths()).map((slugpath) => ({ slugpath }));
}
